import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-docs',
	templateUrl: './docs.component.html',
	styleUrls: ['./docs.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DocsComponent implements OnInit {
	public sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
